/* global system */

export default {
  login({
    callback = null
  } = {}) {
    console.log('login')
    return new Promise((resolve, reject) => {
      system.onmessage = function(data) {
        console.log('system.onmessage: ', data)
        // 取消对于的onmessage的监听
        system.onmessage = null

        data = data ? JSON.parse(data) : {};

        if (data.authcode) {
          let {
            authcode,
            refreshcode = ""
          } = data;

          console.log('callback1', callback)

          // if(callback) callback();
          
          resolve({
            authcode,
            refreshcode,
            isCallBackFirst: callback ? true : false
          })

        } else {
          reject({
            platform: 'quickapp',
            name: data.name || 'QuickAppLoginFailed',
            message: data.message || '登录失败'
          })
        }
      }

      system.postMessage('login')
    })
  },

  logout() {
    console.log('logout')
    return new Promise(resolve => {
      system.postMessage('logout')
      resolve()
    })
  },

  getToken() {
    console.log('getToken')
    return new Promise((resolve, reject) => {
      system.onmessage = function(data) {
        // 取消对于的onmessage的监听
        system.onmessage = null

        try {
          let {
            authcode,
            refreshcode
          } = JSON.parse(data)
          if (!authcode || !refreshcode) {
            reject({
              name: 'AuthError',
              message: '获取用户信息失败(w)'
            })
          } else {
            resolve({
              authcode,
              refreshcode
            })
          }
        } catch (e) {
          console.log(e)
          reject({
            name: 'AuthError',
            message: '获取用户信息失败(w)'
          })
        }
      }

      system.postMessage('getToken')
    })
  },

  // 再次尝试获取token
  refreshToken() {
    console.log('refreshToken')
    return this.getToken();
  }
};



// WEBPACK FOOTER //
// ./src/auth/quickApp.js